<script>
import IconCart from '../icons/IconCart';

export default {
  components: {
    IconCart,
  },
  props: {
    userLoggedIn: Boolean,
    cartQty: Number,
    isWhitelabel: Boolean,
    cart: Object,
  },
};
</script>

<template lang='pug'>
.header-bottom__mobile.flex.w-1-4.items-center.justify-end.whitespace-no-wrap
  router-link(
    v-if='cartQty',
    tag='div',
    :to='{ name: "cart", params: { id: cart.id } }',
  )
    icon-cart.text-brand(:qty='cartQty')

  template(v-else)
    router-link.text-lg.text-brand-secondary.mr-_5.cursor-pointer(
      v-if='isWhitelabel',
      tabindex='0',
      tag='div',
      :to='{ name: "trackOrder" }',
    ) Track

    template(v-else)
      .text-lg.text-brand-secondary.mr-_5.cursor-pointer(
        v-if='userLoggedIn'
        tabindex='0',
        @click='$emit("log-out")',
        @keyup.enter='$emit("log-out")',
      ) Sign Out
      router-link.text-lg.text-brand-secondary.mr-_5.cursor-pointer(
        v-else
        tabindex='0',
        tag='div',
        :to='{ name: "signIn" }',
      ) Sign In
</template>

<style>
@import '~import/index';

</style>